export default "__VITE_ASSET__BkBvZMrL__"